import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/highlightTotalSavingsBasket/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { HIGHLIGHT_TOTAL_SAVINGS_BASKET } from 'constants/TestTarget';

const showHighlightTotalSavingsBasketSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    control: testReady && experience === HIGHLIGHT_TOTAL_SAVINGS_BASKET.CONTROL,
    challengerOne: testReady && experience === HIGHLIGHT_TOTAL_SAVINGS_BASKET.CHALLENGER_ONE,
    challengerTwo: testReady && experience === HIGHLIGHT_TOTAL_SAVINGS_BASKET.CHALLENGER_TWO,
    challengerThree: testReady && experience === HIGHLIGHT_TOTAL_SAVINGS_BASKET.CHALLENGER_THREE,
    challengerFour: testReady && experience === HIGHLIGHT_TOTAL_SAVINGS_BASKET.CHALLENGER_FOUR,
    challengerFive: testReady && experience === HIGHLIGHT_TOTAL_SAVINGS_BASKET.CHALLENGER_FIVE
}));

export { showHighlightTotalSavingsBasketSelector };
